// extracted by mini-css-extract-plugin
export default {"question":"AccordionItem_question__P38gw","answer":"AccordionItem_answer__MmBYF","open":"AccordionItem_open__4-O+n"};